import { ICON__list_check, ICON__list_x } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { useMemo } from 'react';

interface PROPS {
  field: FIELD_PRIMITIVE__string_hash_ml_asset;
}

export function G_UI_FIELD_PRIMITIVE__string_ml_asset_hash__button_select_all({ field }: PROPS) {
  /*
   *
   */

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   *
   */

  const are_all_items_selected = useMemo(() => get_are_all_items_selected(), [field]);

  /*
   *
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let field_new = field.clone();

    if (are_all_items_selected) {
      //select only  used
      let value = field.get_value();
      field_new.set_value_range([value]);
    } else {
      //select all allowed
      field_new.set_value_range(field.get_values_allowed());
    }

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }
  /*
   *
   */

  /*
   *
   */
  function get_are_all_items_selected() {
    let values_range = field.get_value_range();
    let values_allowed = field.get_values_allowed();

    return values_allowed.length == values_range.length;
  }

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   *
   */

  if (!field.meta.grid2d__is_dimension) return <PLACEHOLDER_BUTTON__bar />;
  if (field.get_values_allowed().length <= 1) return <PLACEHOLDER_BUTTON__bar />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      size="3-full"
      variant="no-border-on-bar"
      iconClassNameBase="!text-component-item-foreground size-3"
      iconClassNameHovered="!text-bar-foreground"
      {...{ onClick }}
      disabled={is_disabled()}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      Icon={are_all_items_selected ? ICON__list_x : ICON__list_check}
    />
  );
}
